import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { FileUploadControl } from "@cloudpivot/form/src/common/controls/file-upload-control";
import { UploadStatus } from "@cloudpivot/form/src/common/controls/upload-control";
import FileList from "./file-list.vue";
import { Icon, Button, Upload, Modal } from "@h3/antd-vue";
let PcUpload = class PcUpload extends FileUploadControl {
    constructor() {
        super(...arguments);
        this.previewVisible = false;
        this.previewImage = "";
        this.fileList = [];
        this.eventList = [];
        this.batchFileList = [];
        this.uploadFileList = [];
        this.timer = null;
    }
    showTip() {
        return false;
    }
    ;
    get listType() {
        // 上传图片为 picture-card 样式, 上传文件显示为 text 样式
        return this.isImage ? "picture-card" : "text";
    }
    get showBatchDownload() {
        return this.canBatchDownload && this.fileList.length > 0;
    }
    get canDounload() {
        const fileDown = this.fileList.filter((f) => {
            return f.status === "done" || f.status === 2;
        });
        if (fileDown.length === this.fileList.length) {
            return true;
        }
        else {
            return false;
        }
    }
    get isReadonly() {
        if (this.ctrl) {
            return this.readonly;
        }
        return true;
    }
    unsubscribe() {
        if (this.commandSubscription) {
            this.commandSubscription.unsubscribe();
        }
    }
    setControl() {
        if (this.ctrl && this.ctrl.value) {
            this.toFilelist(this.ctrl.value);
        }
        else {
            // this.fileList = [];
            this.uploadFileList = this.fileList = [];
        }
        this.unsubscribe();
        this.listenCommand();
    }
    handleValueChange(value, changeInfo) {
        // 图片有两种情况,
        // 上传图片和被动赋值.
        // 如果是主动上传图片则不应该 调用this.toFilelist.
        // 如果是赋值则可以调用this.toFilelist. 目前看来每次更新赋值前 value会被设置null.
        if (!value) {
            this.toFilelist(value);
        }
        else if (value.length &&
            (!this.uploadFileList || this.uploadFileList.length === 0)) {
            this.toFilelist(value);
        }
        else if (value && value.length >= 0) {
            this.toFilelist(value);
        }
        else if (value.length === this.uploadFileList.length) {
        }
    }
    toFilelist(val) {
        if (!val) {
            this.uploadFileList = this.fileList = [];
            return;
        }
        //说明此时的数据还未经过转换
        if (Array.isArray(val) && val.length > 0 && val[0].mimeType) {
            val = this.convertFileData(val);
            if (!val)
                return;
        }
        this.uploadFileList = this.fileList = val.map((y) => {
            let x = "";
            if (!y.uid && y.response && y.response.data) {
                x = y.response.data;
            }
            else {
                x = y;
            }
            if (x.response && x.response.data) {
                x.url = this.getDownloadUrl(x.response.data);
                x.previewUrl = this.getPreviewUrl(x.response.data);
            }
            return x;
        });
    }
    listenCommand() {
        const _this = this;
        this.commandSubscription = this.ctrl.commander.subscribe((cmd) => {
            switch (cmd.name) {
                case "clear":
                    _this.fileList = [];
                    _this.ctrl.value = null;
                    break;
                default:
                    break;
            }
        });
    }
    showError(msg) {
        this.$message.error(msg);
    }
    beforeUpload(file) {
        if (!this.checkFileType(file.name, this.showError)) {
            return false;
        }
        if (!this.checkFileSize(file, this.showError)) {
            return false;
        }
        if (!this.checkImageNumber(this.showError)) {
            return false;
        }
        if (!this.checkImageNameLength(file.name, this.showError)) {
            return false;
        }
        file.uploadTime = new Date().getTime();
        let userInfo = window.sessionStorage.getItem("user");
        if (userInfo) {
            userInfo = JSON.parse(userInfo);
        }
        else {
            userInfo = { name: "" };
        }
        file.uploadName =
            window.sessionStorage.getItem("uploadName") || userInfo.name;
        return true;
    }
    onChange(info) {
        clearTimeout(this.timer);
        if (this.isReadonly) {
            return;
        }
        this.uploadFileList = info.fileList.filter((f) => f.status && f.status !== "removed");
        if (this.uploadFileList.length === 0) {
            return;
        }
        //保存文件状态
        let { file } = info;
        const status = info.file.status;
        if (status === "done" && file.response && file.response.errcode === 0) {
            this.batchFileList.push(file);
        }
        // 保存文件上传进度
        this.eventList = this.uploadFileList = this.uploadFileList.map((f) => {
            if (f.response && f.response.errcode === 50000) {
                f.status = UploadStatus.Error;
            }
            const obj = this.batchFileList.filter((v) => {
                if (v.uid === f.uid) {
                    return v;
                }
            });
            return obj && obj.length > 0 ? obj[0] : f;
        });
        // console.log(
        //   this.batchFileList,
        //   "batchFileList",
        //   this.uploadFileList,
        //   this.eventList
        // );
        const files = info.fileList
            .filter((f) => f.status &&
            !(f.status === "removed" || f.status === UploadStatus.Delete))
            .map((f) => {
            // 有服务errorcode = 50000 但是上传状态返回为done的情况 估计是上传接口先上传到服务器  再通过ftp还是oss转移到其他地方
            let serverResponse = f.response;
            if (serverResponse) {
                let errorCode = serverResponse.errcode;
                if (errorCode === 50000) {
                    return {
                        uid: f.uid,
                        name: f.name,
                        size: f.size,
                        type: f.type,
                        status: UploadStatus.Error,
                        response: f.response,
                        url: "",
                        uploadTime: f.uploadTime,
                        uploadName: f.uploadName,
                    };
                }
            }
            const obj = this.batchFileList.filter((v) => {
                if (v.uid === f.uid) {
                    return v;
                }
            });
            if (obj && obj.length > 0) {
                f = obj[0];
            }
            let status = UploadStatus.Uploading;
            switch (f.status) {
                case "done":
                    status = UploadStatus.Done;
                    break;
                case "error":
                    status = UploadStatus.Error;
                    break;
                case "uploading":
                    status = UploadStatus.Uploading;
                    break;
                default:
                    status = f.status;
                    break;
            }
            return {
                uid: f.uid,
                name: f.name,
                size: f.size,
                type: f.type,
                status: status,
                response: f.response,
                url: f.response && f.response.data
                    ? this.getDownloadUrl(f.response.data)
                    : "",
                uploadTime: f.uploadTime,
                uploadName: f.uploadName,
            };
        });
        this.timer = setTimeout(() => {
            super.onFilesChange(files);
        }, 100);
        this.fileList = info.fileList.map((f) => {
            const obj = this.batchFileList.filter((v) => {
                if (v.uid === f.uid) {
                    return v;
                }
            });
            return obj && obj.length > 0 ? obj[0] : f;
        });
    }
    /**
     * @des 删除文件
     */
    rmFile(file) {
        this.uploadFileList = this.uploadFileList.filter((u) => u.uid !== file.uid);
        this.removedFile(file);
    }
    onRemovedImg(file) {
        super.removedFile(file);
    }
    previewFile(file) {
        if (file.status === 2 || file.status === "done") {
            this.handlePreview(file);
        }
    }
    handleCancel() {
        this.previewVisible = false;
    }
    handlePreview(file) {
        // console.log(file)
        if (file.previewUrl) {
            file.previewUrl && window.open(file.previewUrl);
            event && event.stopPropagation();
        }
        else {
            let type = file.type || file.response.data.mimeType;
            if (type.indexOf("image") === -1) {
                this.$message.info("该格式附件暂不支持预览");
                return;
            }
            else {
                this.previewImage = file.url || file.thumbUrl;
                this.previewVisible = true;
            }
        }
    }
    // 下载模板文件
    downTemplate() {
        let templateFile = this.controlOpts.templateFile ?
            this.controlOpts.templateFile : null;
        if (templateFile) {
            try {
                if (typeof JSON.parse(templateFile) === "object" && Array.isArray(JSON.parse(templateFile))) {
                    templateFile = JSON.parse(templateFile);
                }
            }
            catch (error) {
                console.log(error);
            }
            const files = templateFile.map((item) => item.response.data);
            if (files.length === 1) {
                this.download(files[0]);
            }
            else {
                this.downloadAllTemplate(files);
            }
        }
        else {
            return false;
        }
    }
    downloadAll() {
        this.downloadBatch();
    }
    destroyed() {
        super.destroyed();
        this.unsubscribe();
    }
    created() {
        this.init();
    }
};
PcUpload = tslib_1.__decorate([
    Component({
        name: "pc-upload",
        components: {
            AIcon: Icon,
            AButton: Button,
            AUpload: Upload,
            AModal: Modal,
            FileList,
        },
    })
], PcUpload);
export default PcUpload;
